import styled from "styled-components";
import DesignConstants from "../../../../../../constants/DesignConstants";

export const PDFGridWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.XS};
    padding: ${DesignConstants.SPACES.S};
`;

export const PDFSettingsTopBottomWrapper = styled.div`
    display: flex;
`;

export const PDFEditableTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};
    flex-wrap: wrap;
`;

export const PDFTextHeader = styled.div`
    font-size: ${DesignConstants.FONT_SIZES.M};
`;
